import ExceptionHandler from './src/ExceptionHandler.js'
import Btn from './src/Btn.js'
import ColumnFormatter from './src/ColumnFormatter.js'
import DateUtil from './src/DateUtil.js'
import BasicUtil from './src/BasicUtil.js'
import StringUtil from './src/StringUtil.js'
import JasperHandler from './src/JasperHandler.js'
import ExceptionHandlerWindow from './src/ExceptionHandlerWindow.js'
import ValidateHandlerWindow from './src/ValidateHandlerWindow.js'

const install = function (Vue, opts = {}) {
  Vue.prototype.$baize = Baize
}

const Baize = {
  version: '0.1',
  install: install,
  handle: ExceptionHandler.handle,
  btn: Btn,
  dateFormatter: ColumnFormatter.dateFormatter,
  dateTimeFormatter: ColumnFormatter.dateTimeFormatter,
  booleanFormatter: ColumnFormatter.booleanFormatter,
  formatDateToString: DateUtil.format,
  formatDiffer: DateUtil.formatDiffer,
  format2HommizationDate: DateUtil.format2HommizationDate,
  isBoolean: BasicUtil.isBoolean,
  isEmpty: BasicUtil.isEmpty,
  isDate: BasicUtil.isDate,
  toQueryString: BasicUtil.toQueryString,
  getCombo: BasicUtil.getCombo,
  clone: BasicUtil.clone,
  cloneTo: BasicUtil.cloneTo,
  formatTime: StringUtil.formatTime,
  formatFileSize: StringUtil.formatFileSize,
  trimFileName: StringUtil.trimFileName,
  formatCNY: StringUtil.formatCNY,
  trimString: StringUtil.trim,
  formatCNYUpper: StringUtil.formatCNYUpper,
  getFileNameMain: StringUtil.getFileNameMain,
  getFileNameExt: StringUtil.getFileNameExt,
  showExceptionMsg: ExceptionHandlerWindow.showMsg,
  showValidationMsg: ValidateHandlerWindow.showMsg,
  length: BasicUtil.length,
  jasper: JasperHandler,
  frameTitleHeight: 130
}

// 注：基本工具中的方法直接放入Baize中
for (var key in BasicUtil) {
  Baize[key] = BasicUtil[key]
}

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
};

export default Baize



// WEBPACK FOOTER //
// ./src/baize/index.js